export default __webpack_public_path__ + "static/media/Retake-hero-desktop.82eee9ec.mp4";